import React from 'react'
import {useHistory} from 'react-router-dom'

import CalendarEmbed from '@progyny/components/CalendarEmbed'
import {ConsultationCard} from '@progyny/pages/Consultations/components/ConsultationCard'
import {useMeStore} from '@progyny/store/meStore'
import {buildProgramSessionMetadata} from '@progyny/utils/calendarMetadata'
import {getBookingFieldsForProgram} from '@progyny/utils/programBookingFields'
import {shouldLockAttendeeFields} from '@progyny/utils/programLockAttendeeFields'
import {buildRoutingFormResponses} from '@progyny/utils/routingFormResponses'

export interface SessionForBooking {
  id: string
  calcomEventType?: string | null
  title?: string | null
  subtitle?: string | null
  description?: string | null
  bookingDescription?: string | null
}

interface SingleSessionBookingProps {
  session: SessionForBooking
  programSlug: string
  onBookingSuccessful?: () => void
  onDone?: () => void
  onCalendarVisibilityChange?: (visible: boolean) => void
  onBackClick?: () => void
}

const SingleSessionBooking: React.FC<SingleSessionBookingProps> = ({
  session,
  programSlug,
  onBookingSuccessful,
  onDone,
  onCalendarVisibilityChange,
  onBackClick,
}) => {
  const user = useMeStore((s) => s.user)
  const countryCode = useMeStore((s) => s.countryCode)
  const history = useHistory()

  const isBookable = Boolean(session?.calcomEventType)

  React.useEffect(() => {
    onCalendarVisibilityChange?.(isBookable)
    return () => onCalendarVisibilityChange?.(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBookable])

  if (!session?.calcomEventType) return null

  const handleBack = () => {
    history.push(`/consultations/program/${programSlug}`)
  }

  return (
    <ConsultationCard padding='none' borderRadius='lg'>
      <CalendarEmbed
        calLink={session.calcomEventType}
        title={session.title ?? undefined}
        description={session.description ?? undefined}
        additionalContent={session.bookingDescription ?? undefined}
        onBookingSuccessful={onBookingSuccessful}
        onDone={onDone}
        prefillData={{
          email: user?.email || '',
          name: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        }}
        metadata={buildProgramSessionMetadata(
          user?.id || '',
          session?.id || ''
        )}
        bookingFields={
          programSlug ? getBookingFieldsForProgram(programSlug) : undefined
        }
        lockAttendeeFields={shouldLockAttendeeFields(programSlug)}
        routingFormResponses={buildRoutingFormResponses(countryCode)}
        onBack={onBackClick ?? handleBack}
      />
    </ConsultationCard>
  )
}

export default SingleSessionBooking
